import { render, staticRenderFns } from "./issue_health_status.vue?vue&type=template&id=a58aa410"
import script from "./issue_health_status.vue?vue&type=script&lang=js"
export * from "./issue_health_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports